import { Component, ElementRef, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NotificationCounterComponent } from '@shared/src/lib/components/notification-counter/notification-counter.component';
import { NotificationBellIconComponent } from '@shared/src/lib/icons/notification-bell-icon/notification-bell-icon.component';
import { NotificationDropdownComponent } from '@shared/src/lib/components/notification-dropdown/notification-dropdown.component';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from '@shared/src/services/local-storage.service';
import { NotificationService } from '@projects/adir/src/app/services/notification.service';
import { Notifications } from '@projects/adir/src/app/models/notifications.interface';

@Component({
  selector: 'lib-notification-button',
  standalone: true,
  imports: [CommonModule, NotificationBellIconComponent, NotificationCounterComponent, NotificationDropdownComponent],
  templateUrl: './notification-button.component.html',
  styleUrl: './notification-button.component.css',
})
export class NotificationButtonComponent implements OnInit, OnDestroy {
  public userId: number;
  public isDropdownVisible = false;
  public notifications: Notifications.Notification[] = [];
  public versionToken: string | null = null;
  public unreadCount = 0;
  public isFetching = false;
  public isUpdating = false;
  private notificationIntervalId: any;

  constructor(
    private readonly eRef: ElementRef,
    private readonly localStorageService: LocalStorageService,
    private readonly notificationService: NotificationService,
  ) { }

  ngOnInit() {
    const userInfo = this.localStorageService.getData('user');
    if (userInfo) {
      const userObj = JSON.parse(userInfo);
      this.userId = userObj?.userId;
    }
    this.getNotifications();
    this.startNotificationPolling();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownVisible = false;
    }
  }

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  private getNotifications(): void {
    if (this.isFetching) return;

    this.isFetching = true;
    this.notificationService.getNotifications(this.versionToken).subscribe({
      next: (res) => {
        if (res?.notifications) {
          this.notifications = res.notifications.map((item) => ({
            ...item,
            avatar: item.avatar || '',
          }));
          this.versionToken = res.versionToken;
          this.setUnreadCount(this.notifications.filter((n) => n.isUnread).length);
        }
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        this.isFetching = false;
      }
    });
  }

  private startNotificationPolling(): void {
    this.notificationIntervalId = setInterval(() => {
      if (!this.isUpdating) {
        this.getNotifications();
      }
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.notificationIntervalId) {
      clearInterval(this.notificationIntervalId);
    }
  }

  setUnreadCount(count: number): void {
    this.unreadCount = count;
  }
}
